jQuery(document).ready(function($){
	var $nav = $(".elements-tab-nav ul");

	// toggle l’ouverture au clic sur l’onglet actif
	$(".elements-tab-nav .tab-link.active").on("click", function(e){
		e.preventDefault(); 
		e.stopPropagation();
		console.log("elements-tan-nav.js .elements-tab-nav .tab-link.active");
		$(this).closest("ul").toggleClass("open");

	});

	// ferme le menu quand on clique sur un autre item
	$(".elements-tab-nav .tab-link:not(.active)").on("click", function(e){
		e.preventDefault();
		e.stopPropagation();
		console.log("elements-tan-nav.js .elements-tab-nav .tab-link:not(.active)");
		$(this).closest("ul").toggleClass("open");

	});

	// ferme si clic en dehors
	$(document).on("click", function(e){
		if(!$(e.target).closest(".elements-tab-nav").length){
			$(".elements-tab-nav ul").removeClass("open");
		}
	});
});
